import React from 'react';

import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes, useResponsiveCss } from 'craft/hooks';
import { resolvers } from 'craft/resolvers';
import { CommonNodeProperties, CssSelectorId } from 'craft/types';

import { FlexChildAlignmentSettings } from './FlexChildAlignmentSettings';
import { FlexChildLayoutSettings } from './FlexChildLayoutSettings';

interface Props {
  nodeIds: string[];
  cssSelectorId?: CssSelectorId;
}

export const FlexChild = React.memo(({ nodeIds, cssSelectorId }: Props) => {
  const { parentId } = useMultiNodes(nodeIds, (node) => ({
    parentId: node?.data?.parent,
  }));
  const { type: parentType } = useMultiNodes([parentId || '']);

  const parentCssSelectorId = parentType
    ? resolvers[parentType].toolbox?.schema?.Layout?.cssSelectorId
    : undefined;

  const { responsiveCss } = useResponsiveCss(
    [parentId || ''],
    CommonNodeProperties.Multiple,
    parentCssSelectorId,
  );

  if (!parentId || responsiveCss?.display !== 'flex') {
    return null;
  }

  return (
    <Section name="Flex Child">
      <FlexChildLayoutSettings nodeIds={nodeIds} cssSelectorId={cssSelectorId} />
      <FlexChildAlignmentSettings
        nodeIds={nodeIds}
        parentCss={responsiveCss}
        cssSelectorId={cssSelectorId}
      />
    </Section>
  );
});

FlexChild.displayName = 'FlexChild';
